import React from 'react';

const LoadingSkeleton = ({ searchType }) => {
  const SkeletonCard = () => (
    <div className="bg-white rounded-xl border border-gray-200 p-6 animate-pulse">
      <div className="flex items-start space-x-4">
        {/* Profile Image Skeleton */}
        <div className="w-16 h-16 bg-gray-200 rounded-full flex-shrink-0"></div>
        
        {/* Content Skeleton */}
        <div className="flex-1 space-y-3">
          {/* Name and title */}
          <div className="space-y-2">
            <div className="h-5 bg-gray-200 rounded w-48"></div>
            <div className="h-4 bg-gray-200 rounded w-32"></div>
          </div>
          
          {/* Rating */}
          <div className="flex items-center space-x-2">
            <div className="flex space-x-1">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="w-4 h-4 bg-gray-200 rounded"></div>
              ))}
            </div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
          
          {/* Details */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          </div>
          
          {/* Action buttons */}
          <div className="flex space-x-3 pt-2">
            <div className="h-9 bg-gray-200 rounded-lg w-32"></div>
            <div className="h-9 bg-gray-200 rounded-lg w-24"></div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {/* Header Skeleton */}
      <div className="mb-6">
        <div className="h-6 bg-gray-200 rounded w-64 mb-2 animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-48 animate-pulse"></div>
      </div>

      {/* Loading Message */}
      <div className="text-center py-4 mb-6">
        <div className="flex items-center justify-center space-x-2 text-blue-600">
          <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-600 border-t-transparent"></div>
          <span className="text-sm font-medium">
            {searchType === 'doctors' ? 'Finding doctors...' : 
             searchType === 'healthcare-providers' ? 'Finding healthcare providers...' : 
             'Searching healthcare professionals...'}
          </span>
        </div>
      </div>

      {/* Skeleton Cards */}
      <div className="space-y-4">
        {[...Array(5)].map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>

      {/* Bottom loading indicator */}
      <div className="text-center py-8">
        <div className="inline-flex items-center space-x-2 text-gray-500">
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;